import React from "react";
import { connect } from "react-redux";
import {
  addExperience,
  updateExperience,
} from "../../../../../../redux/actions/experience";
import {
  ADD_EXPERIENCE,
  UPDATE_EXPERIENCE,
} from "../../../../../../redux/constants/actionTypes";
import styles from "../../../../Profile.module.css";
import SaveButton from "../../../../../../components/commons/SaveButton";
import ModalHeader from "../../../../../../components/commons/ModalHeader";
import ScrollDivBody from "../../../../../../components/commons/ScrollDivBody";
import HandleApiError from "../../../../../../components/commons/HandleApiError";
import { store } from "../../../../../../redux/store";
import { withTranslation } from "react-i18next";
import { Box, Checkbox } from "@mui/material";
// import { t } from "i18next";

class EditExperience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalTitle: this.props.modalTitle,
      id: this.props.id,
      upload_img: this.props.upload_img,
      title: this.props.title,
      description: this.props.description,
      start_date: this.props.start_date,
      end_date: this.props.end_date,
      employment_type: this.props.employment_type,
      company: this.props.company,
      pictureAsFile: this.props.upload_img,
      error: false,
      message: "",
      isPresent: this.props.end_date ? false : true,
      uploadImageFlag: false,
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.ModalHeaderOnClick = this.ModalHeaderOnClick.bind(this);
    this.ScrollBody = this.ScrollBody.bind(this);
    this.SaveButtonOnClick = this.SaveButtonOnClick.bind(this);
  }
  componentDidMount() {
    if (this.state.upload_img == "") {
      fetch("/Image/apps/profile-resume-edit-view/default-experience.png")
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "exp.png", blob);
          this.setState({
            pictureAsFile: file,
            upload_img:
              "/Image/apps/profile-resume-edit-view/default-experience.png",
          });
        });
    }
  }
  validateForm() {
    const {
      title,
      company,
      employment_type,
      start_date,
      end_date,
      isPresent,
      upload_img,
    } = this.state;

    if (!title.trim()) {
      this.setState({ error: true, message: "Please enter the job title." });
      return false;
    }

    if (!company.trim()) {
      this.setState({ error: true, message: "Please enter the company name." });
      return false;
    }

    if (!employment_type.trim()) {
      this.setState({ error: true, message: "Please enter the employment type." });
      return false;
    }

    if (!start_date) {
      this.setState({ error: true, message: "Please select the start date." });
      return false;
    }

    if (!isPresent && !end_date) {
      this.setState({ error: true, message: "Please select the end date or mark as Present." });
      return false;
    }

    if (!isPresent && new Date(end_date) < new Date(start_date)) {
      this.setState({ error: true, message: "End date cannot be before start date." });
      return false;
    }

    if (!upload_img) {
      this.setState({ error: true, message: "Please upload an experience image." });
      return false;
    }

    return true;
  }
  handleImageChange(event) {
    this.setState({
      upload_img: URL.createObjectURL(event.target.files[0]),
      pictureAsFile: event.target.files[0],
      uploadImageFlag: true,
    });
  }
  ModalHeaderOnClick() {
    this.props.changeEdit();
    document.body.style.overflow = "visible";
  }
  SaveButtonOnClick() {
    if (!this.validateForm()) return;

    const expState = {
      id: this.props.id,
      title: this.state.title,
      description: this.state.description,
      start_date: this.state.start_date,
      employment_type: this.state.employment_type,
      company: this.state.company,
      pictureAsFile: this.state.pictureAsFile,
      uploadImageFlag: this.state.uploadImageFlag,
    };

    if (!this.state.isPresent && this.state.end_date !== null) {
      expState.end_date = this.state.end_date;
    }

    this.props.changeEdit();

    if (this.props.add) {
      this.props.addExperience(expState, ADD_EXPERIENCE).then((res) => {
        if (res.val) {
          document.body.style.overflow = "visible";
          return;
        }
        this.setState({ error: true, message: res.message });
      });
    } else {
      this.props.updateExperience(expState, UPDATE_EXPERIENCE).then((res) => {
        if (res.val) {
          document.body.style.overflow = "visible";
          return;
        }
        this.setState({ error: true, message: res.message });
      });
    }
  }
  ScrollBody() {
    const { t } = this.props;
    return (
      <div>
        <div
          style={{
            // borderBottom: '1px solid #5555555A',
            paddingBottom: 20,
          }}
        >
          <div className={styles.imageUpload}>
            <p className={styles.modal_heading}>{t("profile.media")}*</p>
            <div style={{ display: "flex", borderRadius: "5px" }}>
              <img
                src={this.state.upload_img}
                style={{
                  width: "96px",
                  height: "96px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
              <div style={{ marginLeft: "20px" }}>
                <p className={styles.sub_heading}>
                  {store.getState()?.profile?.user?.user_type === "INDIVIDUAL"
                    ? t("profile.addImageOfYourCompany")
                    : t("profile.addImageOfOrganisation")}
                </p>
                <label style={{ marginLeft: 30 }}>
                  <Box
                    sx={{
                      border: "2px solid #F33070",
                      padding: "8px 20px",
                      borderRadius: 40,
                      cursor: "pointer",
                      background: "#F33070",
                      color: "#fff",
                      ":hover": {
                        background: "#fff",
                        color: "#F33070",
                      },
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      {t("common.upload")}
                    </p>
                  </Box>
                  <input
                    type="file"
                    onChange={this.handleImageChange}
                    style={{ cursor: "pointer", display: "none" }}
                    accept="image/png, image/jpeg, image/svg"
                  />
                </label>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 15,
            }}
          >
            <p className={styles.modal_heading}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: "10px", width: 25 }}
                  src="/Image/Profile/Professional Experience/title.svg"
                />
                {t("profile.title")}*
              </div>
            </p>
            <input
              className={styles.modal_para}
              type="text"
              placeholder={t("profile.modalPlaceholder.ExRetailSalesManager")}
              maxlength="50"
              style={{
                border: "1px solid #5555555A",
                padding: 10,
                fontSize: 15,
                borderRadius: 50,
              }}
              value={this.state.title}
              onChange={(event) => {
                this.setState({ title: event.target.value });
              }}
            />
            <br />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 15,
            }}
          >
            <p className={styles.modal_heading}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: "10px", width: 25 }}
                  src="/Image/Profile/Professional Experience/company.svg"
                />
                {store.getState()?.profile?.user?.user_type === "INDIVIDUAL"
                  ? t("common.company") + "*"
                  : t("common.organisation") + "*"}
              </div>
            </p>
            <input
              className={styles.modal_para}
              type="text"
              placeholder={t("profile.modalPlaceholder.ExWireoutTechnologies")}
              maxlength="50"
              style={{
                border: "1px solid #5555555A",
                padding: 10,
                fontSize: 15,
                borderRadius: 50,
              }}
              value={this.state.company}
              onChange={(event) => {
                this.setState({ company: event.target.value });
              }}
            />
            <br />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <p className={styles.modal_heading}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: "10px", width: 25 }}
                  src="/Image/Profile/Professional Experience/employmentType.svg"
                />
                {t("profile.employmentType")}*
              </div>
            </p>
            <input
              className={styles.modal_para}
              type="text"
              placeholder={t("profile.modalPlaceholder.ExFulltime")}
              maxlength="50"
              style={{
                border: "1px solid #5555555A",
                padding: 10,
                fontSize: 15,
                borderRadius: 50,
              }}
              value={this.state.employment_type}
              onChange={(event) => {
                this.setState({ employment_type: event.target.value });
              }}
            />
            <br />
          </div>
        </div>

        <div className={styles.modal_date}>
          <div>
            <p className={styles.modal_heading}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: "10px", width: 20 }}
                  src="/Image/Profile/Professional Experience/date.svg"
                />
                {t("profile.StartDate")}*
              </div>
            </p>
            <input
              className={styles.modal_para}
              type="date"
              style={{
                border: "1px solid #5555555A",
                padding: 10,
                fontSize: 15,
                borderRadius: 50,
              }}
              value={this.state.start_date}
              onChange={(event) => {
                this.setState({ start_date: event.target.value });
              }}
            />
            <br />
          </div>
          <div>
            <p className={styles.modal_heading}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: "10px", width: 20 }}
                  src="/Image/Profile/Professional Experience/date.svg"
                />
                {t("profile.EndDate")}*
              </div>
            </p>
            <input
              className={styles.modal_para}
              type="date"
              disabled={this.state.isPresent}
              style={{
                border: "1px solid #5555555A",
                padding: 10,
                fontSize: 15,
                borderRadius: 50,
              }}
              value={this.state.end_date}
              onChange={(event) => {
                this.setState({ end_date: event.target.value });
              }}
            />
            <br />
          </div>
          <div>
            <p className={styles.modal_heading}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ marginRight: "10px", width: 20 }}
                  src="/Image/Profile/Professional Experience/date.svg"
                />
                Present
              </div>
            </p>
            <Checkbox
              disableRipple
              checked={this.state.isPresent}
              onChange={(e) =>
                this.setState({ isPresent: e.target.checked, end_date: null })
              }
            />
            <br />
          </div>
        </div>
        <p className={styles.modal_heading}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              style={{ marginRight: "10px", width: 20 }}
              src="/Image/Profile/Professional Experience/description.svg"
            />
            {t("common.description")}
          </div>
        </p>
        <div
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <textarea
            className={styles.modal_para}
            id={styles.textarea}
            cols={55}
            rows={8}
            style={{
              border: "1px solid #5555555A",
              padding: 10,
              fontSize: 15,
              borderRadius: 10,
            }}
            value={this.state.description}
            placeholder={t("profile.describeExperienceWithOrganisation")}
            onChange={(event) => {
              this.setState({ description: event.target.value });
            }}
          />
        </div>
      </div>
    );
  }
  render() {
    return (
      <div id={styles.template_modal} className={`${styles.modal_wrapper}`}>
        <ModalHeader
          title={this.props.modalTitle}
          onClick={this.ModalHeaderOnClick}
        />
        <ScrollDivBody body={this.ScrollBody} />
        <SaveButton onClick={this.SaveButtonOnClick} />
        <HandleApiError
          error={this.state.error}
          message={this.state.message}
          onClose={() => this.setState({ error: false })}
        />
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    updateExperience: (expState, action) =>
      dispatch(updateExperience(expState, action)),
    addExperience: (expState, action) =>
      dispatch(addExperience(expState, action)),
  };
}
export default withTranslation()(
  connect(null, mapDispatchToProps)(EditExperience)
);
